import { useMemo, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ChevronDown, Layers, Search, CheckCheck } from "lucide-react";
import { cn } from "@/lib/utils";

const norm = (s) => (s || "").toLocaleLowerCase("tr");

/** Seri filtresi: tek ya da çoklu seri; "Serilerin ürünlerini seç" ile filtredeki tüm ürünler tek tıkla seçilir. */
export function SeriesFilter({ value, onChange, options, onSelectProducts }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const n = norm(q);
    const all = [...value, ...options.filter((o) => !value.includes(o))];
    return n ? all.filter((o) => norm(o).includes(n)) : all;
  }, [q, options, value]);
  const toggle = (s) => onChange(value.includes(s) ? value.filter((x) => x !== s) : [...value, s]);
  const label = !value.length ? "Tüm seriler" : value.length === 1 ? value[0] : `${value.length} seri seçili`;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" title={value.join(", ")} className={cn("h-9 w-full sm:w-[170px] px-3 rounded-md border text-sm inline-flex items-center gap-2 bg-slate-50 border-slate-200 transition-colors", value.length > 0 && "border-[#0F2745] bg-white font-semibold")} data-testid="portal-filter-series">
          <Layers className="h-3.5 w-3.5 text-slate-400 shrink-0" /><span className="truncate flex-1 text-left">{label}</span><ChevronDown className="h-4 w-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[300px] p-0" data-testid="series-filter-pop">
        <div className="p-2 border-b relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Seri ara…" className="h-8 pl-7 text-sm" data-testid="series-filter-search" />
        </div>
        <div className="max-h-[280px] overflow-y-auto py-1">
          {!list.length && <div className="px-3 py-6 text-center text-xs text-slate-400">Seri bulunamadı</div>}
          {list.map((s, i) => {
            const on = value.includes(s);
            return (
              <div key={s} className={cn("flex items-center gap-2 px-2 py-1.5 mx-1 rounded-md hover:bg-slate-50", on && "bg-amber-50/70")}>
                <Checkbox checked={on} onCheckedChange={() => toggle(s)} data-testid={`series-opt-${i}`} />
                <button type="button" className="flex-1 min-w-0 text-left text-[13px] truncate" onClick={() => toggle(s)} title={s}>{s}</button>
                <button type="button" onClick={() => { onChange([s]); setOpen(false); }} className="text-[10px] font-bold uppercase tracking-wide text-slate-400 hover:text-[#0F2745] px-1" data-testid={`series-only-${i}`}>yalnız</button>
              </div>
            );
          })}
        </div>
        <div className="p-2 border-t flex items-center gap-2">
          <Button variant="ghost" size="sm" disabled={!value.length} onClick={() => onChange([])} data-testid="series-filter-clear">Temizle</Button>
          <Button size="sm" className="ml-auto bg-[#0F2745] hover:bg-[#0F2745]/90" disabled={!value.length} onClick={() => { onSelectProducts(); setOpen(false); }} data-testid="series-select-products">
            <CheckCheck className="h-3.5 w-3.5 mr-1.5" />Ürünlerini seç
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
